import { deleteApi, getApi, postApi, putApi } from "../../common/api";

export const addArea = (data: any) => {
    return postApi('/api/area', data);
};

export const editArea = (data: any, id: any) => {
    return putApi('/api/area/' + id, data);
};

export const listAreas = () => {
    return getApi('/api/area');
};

export const deleteArea = (id: any) => {
    return deleteApi("/api/area/" + id);
};

export const getAreaById = (id: any) => {
    return getApi("/api/area/" + id);
};
